/**
 * migracion_bid_frontend/src/hooks/context.js
 *
 * Contect file for User Data. Developed using React's useContext hook.
 */

import React, { useState, createContext, useContext, useEffect } from "react";
import { getSubtopicData } from "../utils/dataFunctions/getSubtopicData";
import { getTopicData } from "../utils/dataFunctions/getTopicData";
import { getYearAndMonthData } from "../utils/dataFunctions/getYearAndMonthData";
import { getYearAndQuarterData } from "../utils/dataFunctions/getYearAndQuarterData";
import { useCurrentLanguage } from "./useCurrentLanguage";

export const DataContext = createContext();

/**
 *
 * @param {object} props Props object
 *
 * @returns Context Provider component
 */
export const ContextProvider = (props) => {
  const [dateOptions, setDateOptions] = useState(null);
  const [topicOptions, setTopicOptions] = useState(null);
  const [subtopicOptions, setSubtopicOptions] = useState(null);
  const [errorText] = useState("noData");
  const { language } = useCurrentLanguage();

  // Find current user, if one exists.
  useEffect(() => {
    async function getCurrentOptions() {
      const dateOptionsPromise = getYearAndMonthData(true);
      const quarterOptionsPromise = getYearAndQuarterData(language);
      const topicPromise = getTopicData(language);
      const subtopicPromise = getSubtopicData(language);

      Promise.all([
        dateOptionsPromise,
        quarterOptionsPromise,
        topicPromise,
        subtopicPromise,
      ]).then((results) => {
        if (results[0] === "ERROR_LOADING_DATA") {
          setDateOptions(errorText);
          setTopicOptions(errorText);
          setSubtopicOptions(errorText);
          return;
        }

        if (results[1] !== "ERROR_LOADING_DATA") {
          let mostRecentQuarterDate = {
            year: results[1].mostRecentDate.year,
            quarter: results[1].mostRecentDate.quarter,
          };
          results[0]["mostRecentQuarterDate"] = mostRecentQuarterDate;
          results[0].quarterOptions = results[1].quarterOptions;
          results[0].yearOptions[0]["years_list"] =
            "2017 - " + mostRecentQuarterDate.year;
        } else {
          results[0].mostRecentDate.quarter = errorText;
          results[0]["mostRecentQuarterDate"] = errorText;
          results[0].quarterOptions = errorText;
        }

        setDateOptions(results[0]);

        if (results[2] === "ERROR_LOADING_DATA") {
          setTopicOptions(errorText);
        } else {
          setTopicOptions(results[2]);
        }

        if (results[3] === "ERROR_LOADING_DATA") {
          setSubtopicOptions(errorText);
        } else {
          setSubtopicOptions(results[3]);
        }
      });
    }

    getCurrentOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  const value = {
    dateOptions,
    topicOptions,
    subtopicOptions,
    errorText,
  };

  return (
    // DataContext.Provider
    <DataContext.Provider {...props} value={value} />
  );
};

// useContextData goes to components
export const useContextData = () => useContext(DataContext);
